import { render, staticRenderFns } from "./NumberOfSessionsAreaChart.vue?vue&type=template&id=5428d143&"
import script from "./NumberOfSessionsAreaChart.vue?vue&type=script&lang=js&"
export * from "./NumberOfSessionsAreaChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports